export { default } from "./SponsoredCard";
